<template>
    <va-edit-layout>
        <FbaInboundShipment-form
            :id="id"
            :title="title"
            :item="item"
        ></FbaInboundShipment-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
